import React, { useEffect, useRef, useState } from "react";
import CommonInput from "../../../CommonMethhods/CommonInput";
import { Lead_Creation } from "../../../Configuration/API_URL";
import * as Yup from "yup";
import { toast } from "react-toastify";
import {
  AESEncryption,
  ApiResDecrypt,
  formatDate,
  splitDateNewSlash,
  validatePan,
} from "../../../CommonMethhods/CommonMethods";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm, useWatch } from "react-hook-form";
import { useResumeContext } from "../../../CommonMethhods/Context";
import { useClientContext } from "../../../context/ClientContext";
import Loader from "../../../Components/Common/Loader";
import SmallLoader from "../../../Components/Common/smallLoader";
import axiosInstance from "../../../CommonMethhods/axiosInstance";

function BasicDetail(props) {
  const IndiMobileNo = localStorage.getItem("IndiMobileNo");
  const storeToken = localStorage.getItem("ssoToken");
  const prevLengthRef = useRef(0);
  const resumeVal = props?.resumeVal;
  const activeTab = props?.activeTab;
  const { resumeHandle } = useResumeContext();
  const [loader, setLoader] = useState(false);
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(false);
  const [submittedValues, setSubmittedValues] = useState({});
  const { selectedClient, shouldPrefill } = useClientContext();


  const errorSchema = Yup.object().shape({
    nameValid: Yup.string().required("Full Name is required"),
    panValid: Yup.string()
      .required("PAN Number is required")
      .matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, "Enter valid PAN number"),
    //  dobValid: Yup.string()
    // .required("DOB is required")
    // .test("is-valid-date", "Please enter a valid calendar date", function (value) {
    //   if (!value) return false;

    //   const [year, month, day] = value.split("-").map(Number);
    //   const date = new Date(year, month - 1, day);

    //   const isValid =
    //     date &&
    //     date.getFullYear() === year &&
    //     date.getMonth() === month - 1 &&
    //     date.getDate() === day;

    //   if (!isValid) return false;

    //   const today = new Date();
    //   today.setHours(0, 0, 0, 0);

    //   const eighteenYearsAgo = new Date();
    //   eighteenYearsAgo.setFullYear(today.getFullYear() - 18);

    //   if (date > eighteenYearsAgo) {
    //     return this.createError({ message: "You must be at least 18 years old" });
    //   }
    //   return true;
    // }),
    dobValid: Yup.date()
  .typeError("Please enter a valid calendar date")
  .required("DOB is required")
  .max(new Date(), "Date cannot be greater than today")
  .test("is-18", "You must be at least 18 years old", function (value) {
    if (!value) return false;
    const today = new Date();
    const eighteenYearsAgo = new Date();
    eighteenYearsAgo.setFullYear(today.getFullYear() - 18);
    return value <= eighteenYearsAgo;
  }),
  });

  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    reset: resetForm,
    control,
    formState: { errors, isValid },
  } = useForm({
    mode: "all",
    resolver: yupResolver(errorSchema),
  });
  console.log(resumeVal?.basicDetails, "basicDetails");
  

  useEffect(() => {
    if (activeTab !== "individual") {
      resetForm({
        nameValid: "",
        panValid: "",
        dobValid: "",
      });
      setIsSubmitDisabled(false);
      setSubmittedValues({});
    } else if (shouldPrefill && selectedClient?.mobile && resumeVal?.basicDetails) {
      setValue("nameValid", resumeVal?.basicDetails?.fullName || "");
      setValue("panValid", resumeVal?.basicDetails?.pan || "");
      setValue("dobValid", resumeVal?.basicDetails?.dob || "");
    }
  }, [activeTab, shouldPrefill, selectedClient, resumeVal]);

  function convertDateFormat(dateStr) {
    const [day, month, year] = dateStr.split("/");
    // return `${month}-${day}-${year}`;
    return `${month}-${day}-${year}`;
  }
  const currentValues = useWatch({ control });


  function formatDob(dobStr) {
    if (!dobStr) return "";
    if (dobStr instanceof Date) {
      const year = dobStr.getFullYear();
      const month = String(dobStr.getMonth() + 1).padStart(2, "0");
      const day = String(dobStr.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    }
    if (typeof dobStr === "string" && dobStr.includes("-")) {
      const [day, month, year] = dobStr.split("-");
      return `${year}-${month}-${day}`;

    }

    return "";
  }

  const basicDetailsData = async (data) => {
    setLoader(true);

    let dobFormatted = "";
          if (data?.dobValid) {
            dobFormatted = formatDob(data?.dobValid);
          }
    let payloadValue = {
      mobileNo: IndiMobileNo || resumeVal?.verificationDetails?.mobileNo,
      fullName: data?.nameValid,
      dateOfBirth: dobFormatted,
      pan: data?.panValid,
    };
    console.log(payloadValue, "payloadValueBasic");
    
    let encPayload = AESEncryption(payloadValue);
    try {
      const getRelation = await axiosInstance.post(
        Lead_Creation.Basic_Details,

        `"${encPayload}"`,
      );

      const res = ApiResDecrypt(getRelation?.data);
      if (res?.status === 0) {
        // setBasicData(true);
        resumeHandle();
        setSubmittedValues({
          nameValid: data.nameValid.trim(),
          dobValid: dobFormatted,
          panValid: data.panValid.trim(),
        });
        setIsSubmitDisabled(true);
        toast.success(res?.data);
      } else {
        toast.error(res?.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoader(false);
    }
  };

  const NameInput = (event) => {
    const currentValue = event.target.value;
    const uppercasedValue = currentValue.toUpperCase();
    event.target.value = uppercasedValue;
  };

  const finalSubmit = (data) => {
    if (IndiMobileNo !== null || resumeVal?.verificationDetails?.mobileNo !== "") {
      basicDetailsData(data);
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();

    const pastedText = e.clipboardData.getData("text");
    const clean = pastedText
      .toUpperCase()
      .replace(/[^A-Z\s]/g, "")
      .replace(/\s+/g, " ")
      .trim();

    const currentVal = getValues("nameValid") || "";
    let newValue = `${currentVal} ${clean}`.replace(/\s+/g, " ").trim();

    newValue = newValue.slice(0, 40);

    setValue("nameValid", newValue, { shouldValidate: true });
    e.target.value = newValue;
  };

  useEffect(() => {
    if (!isSubmitDisabled || !submittedValues) return;
    const isChanged =
      submittedValues.nameValid !== currentValues?.nameValid?.trim() ||
      submittedValues.dobValid !== currentValues?.dobValid?.trim() ||
      submittedValues.panValid !== currentValues?.panValid?.trim();

    if (isChanged) setIsSubmitDisabled(false);
  }, [currentValues]);

  const handlePanPaste = (e) => {
    e.preventDefault();

    const pastedText = e.clipboardData.getData("text").toUpperCase().trim();
    const cleanText = pastedText.replace(/[^A-Za-z0-9]/g, "").slice(0, 10);
    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;

    if (panRegex.test(cleanText)) {
      setValue("panValid", cleanText, { shouldValidate: true });
    } else {
      console.warn("Invalid PAN format pasted");
    }
  };

  const currentDate = new Date();
  const yyyy = currentDate.getFullYear();
  let mm = currentDate.getMonth() + 1;
  let dd = currentDate.getDate();
  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;
  const FormatedDate = dd + "/" + mm + "/" + yyyy;
  const DateReverse = FormatedDate.split("/").reverse().join("-");

  console.log(DateReverse, "DateReverse");

  return (
    <div className="row border-parent accordian-section-wrapper">
      <form className="individual-form" onSubmit={handleSubmit(finalSubmit)}>
        <>
          <div className="col-sm-6 col-lg-4 card-accordian lead-creation">
            <CommonInput
              label="Full Name"
              name="nameValid"
              placeholder="Enter your full name"
              required
              max={40}
              register={register}
              onChange={(e) => {
                const start = e.target.selectionStart;
                const end = e.target.selectionEnd;

                let input = e.target.value;
                input = input
                  .toUpperCase()
                  .replace(/[^A-Z\s]/g, "")
                  .replace(/\s+/g, " ")
                  .trimStart()
                  .slice(0, 40);

                e.target.value = input;

                e.target.setSelectionRange(start, end);
              }}
              onPaste={handlePaste}
              value={resumeVal?.basicDetails?.fullName}
            />
            <p className="forget-link add-error">
              <span>{errors?.nameValid?.message}</span>
            </p>
          </div>

          <div className="col-sm-6 col-lg-4 card-accordian lead-creation">
            <div className="form-group">
              <label className="form-label">Date of Birth
                <span style={{ color: "red", marginLeft: "3px" }}>*</span></label>
            <input
                type="date"
                className="datepicker form-control text-uppercase"
                id="FromDateApPayout"
                placeholder="DD-MM-YYYY"
                {...register("dobValid")}
                max={DateReverse}                
              />
            <p className="forget-link add-error">
              <span>{errors?.dobValid?.message}</span>
            </p>
            </div>
          </div>

          <div className="col-sm-6 col-lg-4 card-accordian lead-creation">
            <CommonInput
              label="PAN Number"
              name="panValid"
              placeholder="Enter PAN card number"
              required
              register={register}
              onKeyPress={(e) => validatePan(e)}
              // onInput={NameInput}
              max={10}
              onPaste={handlePanPaste}
              value={resumeVal?.basicDetails?.pan}
              onChange={(e) => {
                const start = e.target.selectionStart;
                const end = e.target.selectionEnd;

                let input = e.target.value
                input = input
                  .toUpperCase()
                  .replace(/[^A-Z0-9]/gi, "")
                  .trimStart()
                  .slice(0, 10);

                e.target.value = input;

                e.target.setSelectionRange(start, end);
              }}

            />
            <p className="forget-link add-error">
              <span>{errors?.panValid?.message}</span>
            </p>
          </div>

          <div className="wrap-button">
            <button type="submit"
            className="val-btn-wrap"
              // className={`val-btn-wrap ${(!isValid || isSubmitDisabled) ? "val-btn-wrap disable-btn" : ""}`}
              // disabled={!isValid || isSubmitDisabled}
              >
              {loader ? (
                <div className="loader-alignment">
                  <SmallLoader />
                </div>
              ) : (
                <>Save</>
              )}
            </button>
          </div>
        </>
      </form>
    </div>
  );
}

export default BasicDetail;
